/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Spin } from 'antd'
import React, { useEffect, useState } from 'react'

export default function IframeWithLoader({ src, style }) {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (src) {
      setLoading(true)
    }
  }, [src])

  return (
    <>
      {loading && (
        <div style={{ ...style, flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin />
        </div>
      )}
      <iframe
        onLoad={() => setLoading(false)}
        style={{ flexGrow: 1, height: '100vh', display: loading ? 'none' : 'block' }}
        src={src}
        title="file"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
    </>
  )
}
